export default __webpack_public_path__ + "static/media/ionic.8d243cc3.png";